<template>
  <div>
    <form>
      <div class="clearfix px0">
        <div class="col-12 px0">
          <div class="border muted-border shadow">
            <b-embed type="iframe" scrolling="no" :src="url" aspect="21by9" class="col-12" height="120px"></b-embed>
          </div>
          <b-form-group id="" class="my2">
            <b-form-textarea id="textarea2" v-model="commentwidget" :rows="7" :no-resize="true" style="font-size:12px;" class="regular gibson"></b-form-textarea>
          </b-form-group>
          <button class="col-12 outlined-action-button p2 mx-auto gibson flex justify-center items-center" v-if="show" v-clipboard:copy="commentwidget" v-clipboard:success="success" v-clipboard:error="onError">
            <span class="relative" style="top: 2px;">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-files"><path d='M6 15H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h3l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-3zm0-2V7a2 2 0 0 1 2-2h2V2H2v11h4zm8.172-6H8v11h8V8.828L14.172 7z'/></svg>
            </span>
            <span class="h5 semi-bold ml1 mb0">Kopiér og send til webmaster</span>
          </button>
        </div>
      </div>
    </form>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import VueClipboard from 'vue-clipboard2'
import Simplert from 'vue2-simplert'
export default {
  name: 'commentWidget',
  components: {
    VueClipboard,
    Simplert
  },
  props: ['commentwidget', 'items'],
  data () {
    return {
      myHTML: '',
      show: false,
      haaId: '1',
      label: 'Loading...',
      overlay: 1
    }
  },
  created () {
    this.Reload()
  },
  watch: {
    items: function (newVal, oldVal) {
      this.url = 'https://www.kundematch.dk/newpartner/widgetc.php?id=' + this.haaId + '&company=' + this.items.urltag
      this.show = true
    }
  },
  methods: {
    Reload () {
      this.haaId = localStorage.getItem('haaid')
    },
    copy_clipboard () {
      this.$copyText(this.commentWidget).then(function (e) {
        console.log(this.$el)
      }, function (e) {
        alert('Kan ikke kopiere')
      })
    },
    success () {
      let obj = {
        title: 'Koden er nu kopieret og du kan sætte den ind i en mail til din webmaster',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj)
    },
    onError () {
      alert('Kan ikke kopieres')
    }
  }
}
</script>


// WEBPACK FOOTER //
// commentWidget.vue?3f35c598